import { render, staticRenderFns } from "./superiorityOnlyTitle.vue?vue&type=template&id=469dc3c6&"
import script from "./superiorityOnlyTitle.vue?vue&type=script&lang=js&"
export * from "./superiorityOnlyTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports